import React, { useContext, useEffect, useState } from "react";
import TotalConsultationIcon from "../../assets/total-consultation.svg";
import PendingPaymentIcon from "../../assets/pending-payment.svg";
import TotalConsultationMobileIcon from "../../assets/total-consultation-mob.svg";
import PendingPaymentMobileIcon from "../../assets/pending-payment-mob.svg";
import PastAppointment from "../../assets/PastAppointments.svg";
import DoctorContext from "../ClinicComponents/ClinicWrapper/DoctorContext";

const AppointmentSummary = (props) => {
  const staff_context = useContext(DoctorContext);
  const [doctor_selected, setDoctorSelected] = useState([]);
  const [upcomingAppointmentCount, setupcomingAppointmentCount] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    setupcomingAppointmentCount(props.upcomingAppointmentCount);
    setTotalRecords(props.totalRecords);
  }, [props.totalRecords, props.upcomingAppointmentCount]);

  useEffect(() => {
    let arr = [];
    staff_context.selectedDoctor.map((data) => arr.push(data.doctor_id));
    setDoctorSelected(arr);
  }, [staff_context.selectedDoctor]);

  return (
    <div>
      <div className="d-flex ai-center pt-2">
        <div className="appointment-header-font appointment-summary p-0 appointment-web">
          SUMMARY
        </div>
      </div>
      <div className="d-flex mb-3 appointment-summary-container">
        <div className="appointment-summary-div appointment-web icon-style">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h3>{totalRecords}</h3>
            {/* 153 */}
            <div className="summery-image-container summery-background-blue">
              <img
                src={TotalConsultationIcon}
                alt=""
                className="summery-image"
              />
            </div>
          </div>
          <span>Total Appointments</span>
        </div>
        <div className="appointment-summary-div appointment-web icon-style">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h3>{totalRecords - upcomingAppointmentCount}</h3> {/** 147 */}
            <div className="summery-image-container summery-background-green">
              <img src={PastAppointment} alt="" className="summery-image" />
            </div>
          </div>
          <span>Past Appointments</span>{" "}
        </div>

        <div className="appointment-summary-div appointment-web icon-style">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h3>{upcomingAppointmentCount}</h3> {/**06 */}
            <div className="summery-image-container summery-background-red">
              <img src={PendingPaymentIcon} alt="" className="summery-image" />
            </div>
          </div>
          <span>Upcoming Appointments</span>{" "}
        </div>

        {/* <div className="appointment-pagination-div">{children}</div> */}
        <div class="row d-lg-none d-md-none summery-row-container justify-content-center ml-auto mr-auto">
          <div class="Column">
            <div className="appointment-summary-div appointment-mob icon-style appointment-summery-icon pb-2">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 10,
                }}
              >
                <h3>{totalRecords}</h3> {/**{totalConsultation} */}
                <div className="summery-image-container summery-background-blue">
                  <img
                    src={TotalConsultationMobileIcon}
                    alt=""
                    className="summery-image"
                  />
                </div>
              </div>
              <span>Total Appointments</span>
            </div>
          </div>
          <div class="Column">
            <div className="appointment-summary-div appointment-mob icon-style appointment-summery-icon pb-2">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 10,
                }}
              >
                <h3>{totalRecords - upcomingAppointmentCount}</h3>{" "}
                {/**₹ {totalAmount} */}
                <div className="summery-image-container summery-background-green">
                  <img src={PastAppointment} alt="" className="summery-image" />
                </div>
              </div>
              <span>Past Appointments</span>
            </div>
          </div>
          <div class="Column">
            <div className="appointment-summary-div appointment-mob icon-style appointment-summery-icon pb-2">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 10,
                }}
              >
                <h3>{upcomingAppointmentCount}</h3>{" "}
                {/**₹ {unProcessedPayments} */}
                <div className="summery-image-container summery-background-red">
                  <img
                    src={PendingPaymentMobileIcon}
                    alt=""
                    className="summery-image"
                  />
                </div>
              </div>
              <span>Upcoming Appointments</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentSummary;
